import { App } from 'antd';
import Icon from '../cpn/Icon';
import {  useDingdanshouruDELYHZHMutation, useDingdanzhichuDELYHZHMutation, useFeiyongDELYHZHMutation, useJiekuanDELYHZHMutation } from '../store/DianShangYeWuApi';   
function BankRecordDel(props) {
    const {modal,message} = App.useApp(); 
    const [dingdanshouruDELYHZH] = useDingdanshouruDELYHZHMutation()  
    const [dingdanzhichuDELYHZH] = useDingdanzhichuDELYHZHMutation()  
    const [feiyongDELYHZH] = useFeiyongDELYHZHMutation()  
    const [jiekuanDELYHZH] = useJiekuanDELYHZHMutation()  
    return (
        <Icon type='delete'  onClick={() => {    
            console.log(props);
                    
            modal.confirm({
                title: '点击确定删除银行转账记录',
                content: '删除后不能恢复！',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    if(props.qyyhzh_dj_type_name === '收款单'){
                        dingdanshouruDELYHZH({
                            ddsr_id:props.qyyhzh_dj_id+'',
                        }).then((res) => {
                            if(res.data.Status === 'success') {
                                message.info('删除成功！');
                            }   
                            if(res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    }else if(props.qyyhzh_dj_type_name === '付款单'){
                        dingdanzhichuDELYHZH({
                            ddzc_id:props.qyyhzh_dj_id+'',
                        }).then((res) => {
                            if(res.data.Status === 'success') {
                                message.info('删除成功！');
                            }   
                            if(res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    }else if(props.qyyhzh_dj_type_name === '费用单'){
                        feiyongDELYHZH({
                            fy_id:props.qyyhzh_dj_id+'',
                        }).then((res) => {
                            if(res.data.Status === 'success') {
                                message.info('删除成功！');
                            }   
                            if(res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    }else if(props.qyyhzh_dj_type_name === '借款单'){
                        jiekuanDELYHZH({
                            jk_id:props.qyyhzh_dj_id+'',
                        }).then((res) => {
                            if(res.data.Status === 'success') {
                                message.info('删除成功！');
                            }   
                            if(res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    }
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}/>
    )
}

export default BankRecordDel